import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsProvider } from 'telia-front-react';

interface MarketingProps {
  children: React.ReactNode;
}

const Marketing = ({ children }: MarketingProps): JSX.Element => <AnalyticsProvider group="Marketing">{children}</AnalyticsProvider>;

export default observer(Marketing);
